import { http } from '@/api/client/httpClient';
import type { PagedResult } from '@/api/types/abp';
import type {
  ApplyMarginRateBackupInput,
  ApplyMarginRatesInput,
  ApplyMarginRatesResultDto,
  FetchMarginRateConfigurationsInput,
  FetchMarginRateHistoryInput,
  FetchMarginRatesInput,
  LoadMarginRatePlanResultDto,
  MarginControlOptionsDto,
  MarginControlPageStateDto,
  MarginRateConfigurationListItemDto,
  MarginRateHistoryEventDto,
  MarginRatePlanListItemDto,
  MarginRatePreviewRowDto,
  MarginRateRowDto,
  PreviewMarginRatesInput,
  SaveMarginRatePlanInput,
  SaveMarginRatePlanResultDto,
  TakeMarginRateBackupResultDto,
  UndoMarginRatesResultDto,
} from '@/api/types/marginControl';

const BASE = '/api/app/group-margin-rate-configuration';

export const marginControlApi = {
  getPageState: () => http.get<MarginControlPageStateDto>(`${BASE}/page-state`).then((r) => r.data),
  getOptions: () => http.get<MarginControlOptionsDto>(`${BASE}/options`).then((r) => r.data),
  fetch: (input: FetchMarginRatesInput) =>
    http.post<PagedResult<MarginRateRowDto>>(`${BASE}/fetch`, input).then((r) => r.data),
  preview: (input: PreviewMarginRatesInput) =>
    http.post<MarginRatePreviewRowDto[]>(`${BASE}/preview`, input).then((r) => r.data),
  apply: (input: ApplyMarginRatesInput) =>
    http.post<ApplyMarginRatesResultDto>(`${BASE}/apply`, input).then((r) => r.data),
  getConfigurations: (input: FetchMarginRateConfigurationsInput) =>
    http.get<PagedResult<MarginRateConfigurationListItemDto>>(`${BASE}/configurations`, { params: input }).then((r) => r.data),
  takeBackup: () => http.post<TakeMarginRateBackupResultDto>(`${BASE}/take-backup`, {}).then((r) => r.data),
  applyBackup: (input: ApplyMarginRateBackupInput) =>
    http.post<ApplyMarginRatesResultDto>(`${BASE}/apply-backup`, input).then((r) => r.data),
  getPlans: () => http.get<MarginRatePlanListItemDto[]>(`${BASE}/plans`).then((r) => r.data),
  savePlan: (input: SaveMarginRatePlanInput) =>
    http.post<SaveMarginRatePlanResultDto>(`${BASE}/save-plan`, input).then((r) => r.data),
  loadPlan: (planId: string) =>
    http.post<LoadMarginRatePlanResultDto>(`${BASE}/load-plan`, { planId }).then((r) => r.data),
  deletePlan: (planId: string) => http.post(`${BASE}/delete-plan`, { planId }).then((r) => r.data),
  undo: (configurationId: string) =>
    http.post<UndoMarginRatesResultDto>(`${BASE}/undo`, { configurationId }).then((r) => r.data),
  getHistory: (input: FetchMarginRateHistoryInput) =>
    http.get<PagedResult<MarginRateHistoryEventDto>>(`${BASE}/history`, { params: input }).then((r) => r.data),
};
